import React from 'react'
import Box from '@mui/material/Box'
import Typography from '@mui/material/Typography'
import Divider from '@mui/material/Divider'
import Card from '@mui/material/Card'
import CardContent from '@mui/material/CardContent'
import { useTranslation } from 'react-i18next'

export default function RaceInfo ({ race }) {
  const { t } = useTranslation('raceGuide')
  if (!race?.otherRaceInfo || race.otherRaceInfo.length === 0) {
    return <Box>{t('raceInfo.noInfo')}</Box>
  }

  return (
    <Card
      variant='outlined' sx={{
      width: '100%',
      border: 'none',
      boxShadow: 'none',
      backgroundColor: 'transparent'
    }}
    >
      <CardContent>
        {race.otherRaceInfo.map((info, index) => (
          <React.Fragment key={index}>
            {info.title && (
              <Typography variant='h6' component='div' gutterBottom sx={{ fontWeight: 'bold' }}>
                {info.title}
              </Typography>
            )}

            {info.note
              ? (
                <Typography
                  variant='body1' sx={{
                  fontStyle: 'italic',
                  color: 'text.secondary',
                  fontWeight: 'medium',
                  marginBottom: 2
                }}
                >
                  {info.note}
                </Typography>
                )
              : (
                <Box>
                  {info.dates && (
                  <Typography variant='body1' sx={{ fontWeight: 'medium', marginBottom: 0.5 }}>
                    <strong>{t('raceInfo.dates')}</strong> {info.dates}
                  </Typography>
                  )}

                  {info.times && (
                  <Typography variant='body1' sx={{ fontWeight: 'medium', marginBottom: 0.5 }}>
                    <strong>{t('raceInfo.times')}</strong> {info.times}
                  </Typography>
                  )}

                  {info.location && (
                  <Typography variant='body1' sx={{ fontWeight: 'medium', marginBottom: 1 }}>
                    <strong>{t('raceInfo.location')}</strong> {info.location}
                  </Typography>
                  )}

                  {info.description && (
                  <Typography variant='body1' sx={{ marginBottom: 2 }}>
                    {info.description}
                  </Typography>
                  )}
                </Box>
                )}

            {index < race.otherRaceInfo.length - 1 && <Divider sx={{ marginY: 2 }} />}
          </React.Fragment>
        ))}
      </CardContent>
    </Card>
  )
}
